import { SET_LIBRARY_FILTER, SET_BOARD_FILTER, SET_SIDEBAR_FILTER, SET_PROJECTS_FILTER } from '../actionsTypes/filter';

export const setLibraryFilter = (payload) => ({ type: SET_LIBRARY_FILTER, payload });
export const setBoardFilter = (payload) => ({ type: SET_BOARD_FILTER, payload });
export const setSidebarFilter = (payload) => ({ type: SET_SIDEBAR_FILTER, payload });
export const setProjectsFilter = (payload) => ({ type: SET_PROJECTS_FILTER, payload });
